import { ENUM_ROLES, USER_ROLES } from "@entities/user";
import { TRACK_ORDERS_ALLOWED_EMAILS } from "@entities/self-connect-order";
import { AddChannelPage } from "@pages/AddChannel";
import { AdminAccountingPage } from "@pages/AdminAccounting";
import { AdminChannelsPage } from "@pages/AdminChannels";
import { AdminComplaintInfoPage } from "@pages/AdminComplaintInfo";
import { AdminComplaintsPage } from "@pages/AdminComplaints";
import { AdminDocumentsPage } from "@pages/AdminDocuments/UI";
import { AdminOrderTransferPage } from "@pages/AdminOrderTransfer";
import { AdminMailingPage } from "@pages/AdminMailing";
import { AdminChannelOwnerSwapPage } from "@pages/AdminChannelOwnerSwap";
import { AdminOrderUpdatePage } from "@pages/AdminOrderUpdate";
import { AdminOrderPublishPage } from "@pages/AdminOrderPublish";
import { AdminProjectCompletePage } from "@pages/AdminProjectComplete";
import { AdminManageProjectsPage } from "@pages/AdminManageProjects";
import { AdminDeleteOrganizationPage } from "@pages/AdminDeleteOrganization";
import { AdminCommonObservePage } from "@pages/AdminCommonObserve";
import { AdminHomePage } from "@pages/AdminHome";
import { AdminOrganizationPage } from "@pages/AdminOrganization";
import { AdminReviewsPage } from "@pages/AdminReviews";
import { AdminTransactionsPage } from "@pages/AdminTransactions";
import { AdminUserInfoPage } from "@pages/AdminUserInfo";
import { AdminUserGroupInfoPage } from "@pages/AdminUserGroupInfo";
import { AdminUserGroupsPage } from "@pages/AdminUserGroups";
import { AdminUsersPage } from "@pages/AdminUsers";
import { ProjectPage } from "@pages/Project";
import { ProjectReportPage } from "@pages/ProjectReport";
import { CartPage } from "@pages/Cart";
import { CatalogPage } from "@pages/Catalog";
import { ChannelPage } from "@pages/Channel";
import { CreateOrderPage } from "@pages/CreateOrder";
import { DocumentsPage } from "@pages/Documents";
import { FAQPage } from "@pages/FAQ";
import { LoginPage } from "@pages/Login";
import { OAuthCallbackPage } from "@pages/OAuthCallback";
import { MainPage } from "@pages/Main";
import { MainBloggerPage } from "@pages/MainBlogger";
import { MyChannelsPage } from "@pages/MyChannels";
import { NotFoundPage } from "@pages/NotFound";
import { OffersPage } from "@pages/Offers";
import { TrackOrdersPage } from "@pages/TrackOrders";
import { OrdersPage } from "@pages/Orders";
import { PostTemplatesPage } from "@pages/PostTemplates";
import { ProfilePage } from "@pages/Profile";
import { PublicOfferPage } from "@pages/PublicOffer";
import { RegistrationPage } from "@pages/Registration";
import { ServiceRulesPage } from "@pages/ServiceRules";
import { TopupPage } from "@pages/Topup";
import { TurnkeyPage } from "@pages/Turnkey";
import { WalletHistoryPage } from "@pages/WalletHistory";
import { WithdrawalPage } from "@pages/Withdrawal";
import { GuidePage } from "@pages/Guide";
import {
  ENUM_AUTH_TYPES,
  ENUM_LAYOUT_TYPES,
  ENUM_PATHS,
  IRouting,
} from "@shared/routing";

export const ALL_APP_ROUTES_LIST: IRouting[] = [
  // only public
  {
    path: ENUM_PATHS.LOGIN,
    component: LoginPage,
    auth: ENUM_AUTH_TYPES.ONLY_PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.REGISTRATION,
    component: RegistrationPage,
    auth: ENUM_AUTH_TYPES.ONLY_PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.OAUTH_CALLBACK,
    component: OAuthCallbackPage,
    auth: ENUM_AUTH_TYPES.ONLY_PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // public blogger
  {
    path: ENUM_PATHS.MAIN_BLOGGER,
    component: MainBloggerPage,
    roles: [ENUM_ROLES.BLOGGER],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // public advertiser
  {
    path: ENUM_PATHS.MAIN,
    component: MainPage,
    roles: [ENUM_ROLES.ADVERTISER],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  {
    path: ENUM_PATHS.TURNKEY,
    component: TurnkeyPage,
    roles: [ENUM_ROLES.ADVERTISER],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // public common
  {
    path: ENUM_PATHS.FAQ,
    component: FAQPage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.GUIDE,
    component: GuidePage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.PROJECT_PAGE,
    component: ProjectPage,
    // Раньше — публичная агентская страница по ?permission=:
    // roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    // auth: ENUM_AUTH_TYPES.PUBLIC,
    roles: [ENUM_ROLES.ADVERTISER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.PROJECT_REPORT,
    component: ProjectReportPage,
    roles: [ENUM_ROLES.ADVERTISER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.NOT_FOUND,
    component: NotFoundPage,
    roles: [
      ...USER_ROLES,
      ENUM_ROLES.AGENCY,
      ENUM_ROLES.MANAGER,
      ENUM_ROLES.MODERATOR,
    ],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.CHANNEL,
    component: ChannelPage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY, ENUM_ROLES.MANAGER],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.PUBLIC_OFFER,
    component: PublicOfferPage,
    roles: USER_ROLES,
    auth: ENUM_AUTH_TYPES.PUBLIC,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.SERVICE_RULES,
    component: ServiceRulesPage,
    roles: USER_ROLES,
    auth: ENUM_AUTH_TYPES.PUBLIC,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // private blogger
  {
    path: ENUM_PATHS.ADD_CHANNEL,
    component: AddChannelPage,
    roles: [ENUM_ROLES.BLOGGER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.MY_CHANNELS,
    component: MyChannelsPage,
    roles: [ENUM_ROLES.BLOGGER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.OFFERS,
    component: OffersPage,
    roles: [ENUM_ROLES.BLOGGER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.TRACK_ORDERS,
    component: TrackOrdersPage,
    roles: [ENUM_ROLES.BLOGGER],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ROOT,
    allowedEmails: TRACK_ORDERS_ALLOWED_EMAILS,
  },

  // private advertiser & manager & agency
  {
    path: ENUM_PATHS.ORDERS,
    component: OrdersPage,
    roles: [ENUM_ROLES.ADVERTISER, ENUM_ROLES.MANAGER, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.CATALOG,
    component: CatalogPage,
    roles: [ENUM_ROLES.ADVERTISER, ENUM_ROLES.MANAGER, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.CART,
    component: CartPage,
    roles: [ENUM_ROLES.ADVERTISER, ENUM_ROLES.MANAGER, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PUBLIC,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.CREATE_ORDER,
    component: CreateOrderPage,
    roles: [ENUM_ROLES.ADVERTISER, ENUM_ROLES.MANAGER, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.POST_TEMPLATES,
    component: PostTemplatesPage,
    roles: [ENUM_ROLES.ADVERTISER, ENUM_ROLES.MANAGER, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // private common
  {
    path: ENUM_PATHS.DOCUMENTS,
    component: DocumentsPage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.WALLET_TOP_UP,
    component: TopupPage,
    roles: USER_ROLES,
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.WALLET_WITHDRAW,
    component: WithdrawalPage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.WALLET_HISTORY,
    component: WalletHistoryPage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },
  {
    path: ENUM_PATHS.PROFILE,
    component: ProfilePage,
    roles: [...USER_ROLES, ENUM_ROLES.AGENCY],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    authSidebar: true,
    layout: ENUM_LAYOUT_TYPES.ROOT,
  },

  // private admin
  {
    path: ENUM_PATHS.ADMIN_HOME,
    component: AdminHomePage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_CHANNELS,
    component: AdminChannelsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_USERS,
    component: AdminUsersPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_COMPLAINTS,
    component: AdminComplaintsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_TRANSACTIONS,
    component: AdminTransactionsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_REVIEWS,
    component: AdminReviewsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_COMPLAINT_INFO,
    component: AdminComplaintInfoPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_USER_INFO,
    component: AdminUserInfoPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_USER_GROUPS,
    component: AdminUserGroupsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_USER_GROUP_INFO,
    component: AdminUserGroupInfoPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_ORGANIZATION,
    component: AdminOrganizationPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_ACCOUNTING,
    component: AdminAccountingPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_DOCUMENTS,
    component: AdminDocumentsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_ORDER_TRANSFER,
    component: AdminOrderTransferPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_TRACK_ORDERS,
    component: TrackOrdersPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_COMMON_OBSERVE,
    component: AdminCommonObservePage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_MAILING,
    component: AdminMailingPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_CHANNEL_OWNER_SWAP,
    component: AdminChannelOwnerSwapPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_ORDER_UPDATE,
    component: AdminOrderUpdatePage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_ORDER_PUBLISH,
    component: AdminOrderPublishPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_PROJECT_COMPLETE,
    component: AdminProjectCompletePage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_MANAGE_PROJECTS,
    component: AdminManageProjectsPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
  {
    path: ENUM_PATHS.ADMIN_DELETE_ORGANIZATION,
    component: AdminDeleteOrganizationPage,
    roles: [ENUM_ROLES.MODERATOR],
    auth: ENUM_AUTH_TYPES.PRIVATE,
    layout: ENUM_LAYOUT_TYPES.ADMIN,
    adminSidebar: true,
  },
];
